import { FREQUENCY_OPTIONS } from '@funnels/constants';

import { DropdownField } from '../../Fields';
import { EditableViewProps } from '../types';

interface RepaymentsFrequencyTeamViewProps extends EditableViewProps {
  disableFailMessage?: boolean;
  name: string;
  label?: string;
  validationFailMessage?: string;
  shouldAnchorList?: boolean;
}
export const RepaymentsFrequencyTeamView = (props: RepaymentsFrequencyTeamViewProps) => {
  const {
    name,
    label,
    isOptional,
    isDisabled,
    disableFailMessage,
    validationFailMessage,
    shouldAnchorList = false,
  } = props;

  return (
    <DropdownField
      label={label}
      name={name}
      options={FREQUENCY_OPTIONS}
      isOptional={isOptional}
      isDisabled={isDisabled}
      disableFailMessage={disableFailMessage}
      validationFailMessage={validationFailMessage}
      isFullWidth
      shouldAnchorList={shouldAnchorList}
    />
  );
};
